import { z } from 'zod';
import { defineEndpoint } from '../define';

export const RoleSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  isSystem: z.boolean(),
  permissions: z.array(z.string()),
});

export type RoleListItem = z.infer<typeof RoleSchema>;

export const ListRolesResponseSchema = z.object({
  data: z.array(RoleSchema),
});

export const listRoles = defineEndpoint({
  method: 'GET',
  path: '/v1/roles',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: ListRolesResponseSchema,
});
